import { ReactNode } from 'react';

export const formatMessagesText = (
  text: string,
): { lastUserName: string | null; textFormatted: ReactNode } => {
  const parts = text.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g);
  let lastUserName = null;

  const textFormatted = parts.map((part, index) => {
    if (part.startsWith('*') && part.endsWith('*')) {
      const partReplaced = part.replaceAll('*', '');
      lastUserName = partReplaced;
      return <strong key={index}>{partReplaced}</strong>;
    }
    return part;
  });

  return {
    lastUserName,
    textFormatted,
  };
};
